let context: AudioContext | null = null;
let unlocked = false;
const buffers: Record<string, AudioBuffer> = {};

export const unlockAudioContext = async () => {
  if (!context) context = new AudioContext();
  if (context.state === 'suspended') {
    await context.resume();
  }
  unlocked = true;
};

export const preloadAudio = async (src: string) => {
  if (!context) context = new AudioContext();
  if (buffers[src]) return;

  const response = await fetch(src);
  const arrayBuffer = await response.arrayBuffer();
  const audioBuffer = await context.decodeAudioData(arrayBuffer);
  buffers[src] = audioBuffer;
};

export const playAudioFromContext = async (src: string) => {
  if (window.isSoundEnabled === false) {
    return;
  }

  try {
    if (!context) context = new AudioContext();

    if (!unlocked) {
      // fallback (в случае если пользователь явно не кликал)
      const audio = new Audio(src);
      audio.play().catch(err => {
        console.error('Ошибка воспроизведения аудио (без AudioContext):', err);
      });
      return;
    }

    if (!buffers[src]) await preloadAudio(src);

    const source = context.createBufferSource();
    source.buffer = buffers[src];
    source.connect(context.destination);
    source.start(0);
  } catch (err) {
    console.error('Ошибка AudioContext воспроизведения:', err);
  }
};
